module.exports = __webpack_public_path__ + "static/media/1.c8c3c6f3.jpg";